import { Injectable, Injector } from '@angular/core';
import { ComponentPortal } from '@angular/cdk/portal';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';

import { AIAssistantComponent } from '../components/ai-assistant/ai-assistant.component';

@Injectable({
	providedIn: 'root'
})
export class AIAssistantOpenerService {

	private overlayRef: OverlayRef = null;

	constructor(private injector: Injector, private overlay: Overlay) {}

	public openChat(topOffset: number = 0): void {
		if (this.overlayRef) return;
		this.overlayRef = this.overlay.create({
			height: `calc(100vh - ${topOffset}px)`,
			positionStrategy: this.overlay.position().global().top(`${topOffset}px`).right(),
			hasBackdrop: false,
			backdropClass: 'cdk-overlay-dark-backdrop',
			panelClass: 'ai-assistant-panel'
		});
		const portal = new ComponentPortal(AIAssistantComponent, null, this.injector);
		const componentRef = this.overlayRef.attach(portal);
		componentRef.instance.close.subscribe(() => this.closeChat());
		this.overlayRef.backdropClick().subscribe(() => this.closeChat());
	}

	public closeChat(): void {
		this.overlayRef?.dispose();
		this.overlayRef = null;
	}
}
